module.exports = __webpack_public_path__ + "Server-Unknown.TentaclePassive.cc0b582b60bbc0369593a01f16734d6d.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unknown.TentaclePassive.png
// module id = 8927491475744201
// module chunks = 1